"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductPopupLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _accidentalInjuryPopup = require("./accidentalInjuryPopup");
var _illnessPopup = require("./illnessPopup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var RegisteredPopups = {
  accidentalInjury: _accidentalInjuryPopup.AccidentalInjuryPopup,
  coversIllness: _illnessPopup.IllnessPopup
};
var ProductPopupLink = exports.ProductPopupLink = function ProductPopupLink(_ref) {
  var labelKey = _ref.labelKey,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    productDefinition = _ref.productDefinition,
    labelDefinition = _ref.labelDefinition,
    _ref$isLabelCell = _ref.isLabelCell,
    isLabelCell = _ref$isLabelCell === void 0 ? true : _ref$isLabelCell;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    popupVisible = _useState2[0],
    setPopupVisible = _useState2[1];
  var popup = labelDefinition.popup;
  if (!popup) {
    return null;
  }
  var location = popup.location,
    _popup$link = popup.link,
    label = _popup$link.label,
    cssClass = _popup$link.cssClass;
  if (location === 'value' && isLabelCell || location === 'label' && !isLabelCell) {
    return null;
  }
  var TogglePopupState = function TogglePopupState() {
    setPopupVisible(!popupVisible);
  };
  var PopupElement = function PopupElement(props) {
    return RegisteredPopups[labelKey](props);
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "productPopupLink"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: TogglePopupState,
    type: "button",
    className: "button ".concat(cssClass)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, label), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "caret_right"
  })), popupVisible && /*#__PURE__*/_react["default"].createElement(PopupElement, {
    onPopupClose: function onPopupClose() {
      return setPopupVisible(false);
    },
    productDefinition: productDefinition
  })));
};
ProductPopupLink.propTypes = {
  labelKey: _propTypes["default"].string,
  /* eslint-disable-next-line react/forbid-prop-types */
  productDefinition: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  labelDefinition: _propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
    subLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
    footnote: _propTypes["default"].bool,
    tooltip: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
    popup: _propTypes["default"].shape({
      location: _propTypes["default"].string,
      link: _propTypes["default"].shape({
        label: _propTypes["default"].string,
        cssClass: _propTypes["default"].string
      })
    })
  }),
  isLabelCell: _propTypes["default"].bool
};
var _default = exports["default"] = {
  ProductPopupLink: ProductPopupLink
};